import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Activity, Star } from "lucide-react";
import { api } from "../lib/api";

export default function ActivityFeed({ limit = 8 }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.activityFeed(limit).then((d) => setItems(d.slice(0, limit))).catch(() => {});
  }, [limit]);

  if (items.length === 0) return null;

  return (
    <section className="max-w-7xl mx-auto px-4 lg:px-8 py-12" data-testid="activity-feed">
      <div className="flex items-end justify-between mb-6">
        <div>
          <div className="font-mono text-[10px] uppercase tracking-widest text-[#FEBA01] flex items-center gap-1">
            <Activity size={12} /> En vivo
          </div>
          <h2 className="font-display text-4xl uppercase tracking-tight">La camada está activa</h2>
        </div>
        <Link
          to="/comunidad"
          className="font-display uppercase tracking-wider text-sm text-[#FEBA01] hover:underline"
          data-testid="home-see-feed"
        >
          Ver feed →
        </Link>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3">
        {items.map((r) => (
          <div
            key={r.id}
            className="bg-[#1A1A1A] border-2 border-[#333] p-4 hover:border-[#FEBA01] transition-colors"
            data-testid={`feed-item-${r.id}`}
          >
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center gap-2">
                <div className="w-7 h-7 bg-[#FEBA01] text-black flex items-center justify-center font-display text-xs">
                  {String(r.user_handle || "?").slice(0, 1).toUpperCase()}
                </div>
                <div className="font-display uppercase text-sm leading-none">{r.user_handle || "anonimo"}</div>
              </div>
              {r.rating != null && (
                <div className="flex items-center gap-0.5 text-[#FEBA01] text-xs">
                  <Star size={10} className="fill-[#FEBA01]" /> {r.rating}
                </div>
              )}
            </div>
            <Link
              to={`/local/${r.venue_id}`}
              className="font-display text-base uppercase tracking-tight text-[#FEBA01] hover:underline block"
            >
              {r.venue_name || "—"}
            </Link>
            {r.text && (
              <p className="mt-2 text-xs text-[#A3A3A3] italic line-clamp-3">&ldquo;{r.text}&rdquo;</p>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}
